import { z } from 'zod';

/**
 * The identity a task has in the system that OWNS it. Trusstor never mints one
 * and never edits one: it is the external planning system's primary key, and it
 * is what makes `POST /externalActivities` idempotent — a second call with the
 * same triple returns the first call's records instead of creating a second set.
 *
 * All three parts are load-bearing. `system` namespaces one integration against
 * another, `siteId` is the external system's own site identifier (kept for
 * traceability and support — Trusstor's project is the path's `:projectId`, not
 * this), and `taskId` identifies the task within that site.
 *
 * Uniqueness is enforced per project by a PARTIAL unique index on
 * `(projectId, externalRef.system, externalRef.taskId)` over both
 * `sequenceItems` and `activitiesGroup` — see `Common/src/db/indexes.js`.
 *
 * Schema (source of truth) — pure validation, no transforms. Non-emptiness is a
 * WIRE concern and lives in `externalActivity.contract.ts`, matching every other
 * interface in this folder: these describe the stored shape, the contracts
 * describe what a caller may send.
 */
export const externalRefSchema = z.object({
	system: z.string(),
	siteId: z.string(),
	taskId: z.string(),
});

// Types (derived from schemas)
export type IExternalRef = z.infer<typeof externalRefSchema>;
